import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '🎨',
  title: '50 Creative Activities',
  description: 'A wide variety of ideas to keep your kids entertained and learning every day.',
  bgColor: 'bg-pastel-peach'
}, {
  emoji: '🏠',
  title: 'Indoor & Outdoor',
  description: 'Activities designed for playing inside the house or out in the open air.',
  bgColor: 'bg-pastel-green'
}, {
  emoji: '🧠',
  title: 'Skill Building',
  description: 'Fine motor skills, attention, language, and creativity in every activity.',
  bgColor: 'bg-pastel-blue'
}, {
  emoji: '📦',
  title: 'Simple Materials',
  description: 'You only need things you already have at home. No special purchases required.',
  bgColor: 'bg-pastel-yellow'
}, {
  emoji: '📋',
  title: 'Step-by-Step Instructions',
  description: 'Clear, easy-to-follow guides — even on your busiest days.',
  bgColor: 'bg-pastel-purple'
}, {
  emoji: '⏱️',
  title: 'Quick to Set Up',
  description: 'Activities you can organize in minutes, not hours.',
  bgColor: 'bg-pastel-pink'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BenefitsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-7">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-8">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-9">
          What's Inside This E-book?
        </h2>
        <div className="w-24 h-1 bg-brand-sage mx-auto rounded-full" data-id="element-10"></div>
      </motion.div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-11">
        {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className={`${benefit.bgColor} p-8 rounded-3xl shadow-sm border border-black/5 flex flex-col items-start`} data-id="element-12">
            <div className="text-4xl mb-4 bg-white/50 w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm" data-id="element-13">
              {benefit.emoji}
            </div>
            <h3 className="text-xl font-bold mb-3 text-brand-brown-dark" data-id="element-14">
              {benefit.title}
            </h3>
            <p className="text-brand-gray-warm leading-relaxed" data-id="element-15">
              {benefit.description}
            </p>
          </motion.div>)}
      </motion.div>
    </section>;
}